import React, { useEffect, useState } from "react";
import firebase from "firebase/compat/app";
import "firebase/compat/analytics";
import axios from "axios";
import { Button } from "primereact/button";

export default function Product({ id }) {
    const [data, setData] = useState(null);
    useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        let data = await axios.get(
            `https://rohdemusik.de/wp-json/wp/v2/product/${id}`
        );
        setData(data.data);
    };

    const openProduct = () => {
        const analytics = firebase.analytics();
        analytics.logEvent("open_product", {
            product_id: id,
            product_name: data.title.rendered,
        });
        analytics.logEvent("open_product_carousel", {
            product_id: id,
            product_name: data.title.rendered,
        });
        window.location = data.link;
    };

    return data ? (
        <div className="product-item">
            <div className="product-item-content">
                <div className="mb-3" onClick={openProduct}>
                    <img
                        src={data.yoast_head_json.og_image[0].url}
                        alt={data.yoast_head_json.title}
                        className="product-image"
                    />
                </div>
                <div>
                    <h4 className="mb-1 produktName">
                        {data.yoast_head_json.title.replace(
                            "- rohdemusik.de",
                            ""
                        )}
                    </h4>
                    <p>{data.yoast_head_json.description}</p>
                    <div className="car-buttons mt-5">
                        <Button
                            className="p-button p-button-rounded mr-2"
                            onClick={openProduct}
                        >
                            {" "}
                            Ansehen{" "}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    ) : (
        <div></div>
    );
}
